import { styled, css } from "../../../styled-components";

export const maximumLeftWidthSmall = 320;
export const maximumLeftWidthLarge = 375;
const maximumDetailWidth = 700;
export const leftPanelExpandBreakpoint = maximumDetailWidth + maximumLeftWidthLarge + 16;

const defaultModalWidth = css`
    min-width: 500px;
    width: 50%;
    max-width: 700px;
`;

const modalWidthOverride = css<{ modalWidth?: number }>`
    width: ${p => p.modalWidth}px;
`;

const defaultModalHeight = css`
    height: 80%;
    max-height: 800px;
`;

const modalHeightOverride = css<{ modalHeight?: number }>`
    height: ${p => p.modalHeight}px;
`;

interface Props {
    expandLeftPanel: boolean;
    modalWidth?: number;
    modalHeight?: number;
}
export const TabletWrapper = styled.div<Props>`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;

    --maximum-detail-width: 700px;

    & *::-webkit-scrollbar {
        display: none;
    }

    & > .left-panel {
        position: relative;
        width: ${p => (p.expandLeftPanel ? maximumLeftWidthLarge : maximumLeftWidthSmall)}px;
        background-color: ${p => p.theme.baseColor};
        border-right: 1px solid ${p => p.theme.separatorColor};
    }

    & > .right-panel {
        flex-grow: 1;
        display: flex;

        position: relative;
    }

    & > .center-panel {
        position: absolute;

        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: center;
    }

    & .content-wrapper {
        position: relative;
        width: 100%;
    }

    & .tablet-modal {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: ${p => p.theme.veilColor};

        display: flex;
        justify-content: center;
        align-items: center;

        z-index: 29;

        transition: background-color 200ms;

        animation: tablet-modal-enter 200ms linear forwards;
        animation-iteration-count: 1;
    }

    @keyframes tablet-modal-enter {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    & .tablet-modal-content {
        position: relative;
        background-color: ${p => p.theme.offBaseColor};
        ${p => (p.modalWidth !== undefined ? modalWidthOverride : defaultModalWidth)};
        ${p => (p.modalHeight !== undefined ? modalHeightOverride : defaultModalHeight)};
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);

        border-radius: 12px;
        overflow: hidden;

        transition: transform 200ms ease-out, opacity 200ms;

        animation: tablet-modal-content-enter 200ms linear;
        animation-iteration-count: 1;
    }

    @keyframes tablet-modal-content-enter {
        0% {
            opacity: 0;
            transform: translateY(60%);
        }
        100% {
            opacity: 1;
        }
    }

    & .tablet-modal.leave {
        background-color: transparent;
        pointer-events: none;

        > * {
            transform: translateY(60%);
            opacity: 0;
        }

        * {
            pointer-events: none !important;
        }
    }

    & .tablet-modal-scr {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    & .tablet-modal-bar {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }

    background-color: ${p => p.theme.offBaseColor};
`;

export const LeftNavBarWrapper = styled.div<{ expandLeftPanel: boolean }>`
    position: absolute;
    left: 0;
    width: ${p => (p.expandLeftPanel ? maximumLeftWidthLarge : maximumLeftWidthSmall)}px;
    top: 0;
`;

export const RightNavBarWrapper = styled.div<{ expandLeftPanel: boolean }>`
    position: absolute;
    left: ${p => (p.expandLeftPanel ? maximumLeftWidthLarge : maximumLeftWidthSmall)}px;
    top: 0;
    right: 0;
`;

export const CenterNavBarWrapper = styled.div<{ expandLeftPanel: boolean }>`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
`;
